import { OptionType } from './shared';

export interface PositionLeg {
  id: string;
  sym: string;
  type: OptionType;
  strike: number;
  quantity: number;
  expiration: number;
  price: number;
}

export interface PositionShares {
  sym: string;
  quantity: number;
  pricePaid: number;
}

export type Position = PositionLeg[];

export const OC_STORAGE_KEY = 'options_calculator_legs';
export const OC_SHARES_KEY = 'options_calculator_shares';
export const OC_SYM_KEY = 'options_calculator_sym';

export const OC_DEFAULT_SYM = 'SPY';

export const OC_DEFAULT_IV_SETTINGS: IVAdjustmentSettings = {
  levelShift: 0,
  callSlopeMultiplier: 1,
  putSlopeMultiplier: 1,
};

export interface IVAdjustmentSettings {
  levelShift: number; // Parallel shift
  callSlopeMultiplier: number; // Steepen/flatten
  putSlopeMultiplier: number; // Steepen/flatten
}
